// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CheckoutModal — shared checkout of one offer ("Pasarela de pago" step,
   @/ui/Modal shell). Styles inherited from the retired CheckoutDrawer (which
   mirrored the vd-co-* / vd-btn / vd-alert set that lived in
   VerDiligenciaRoute.css). Pending back-port: the info alert also exists as
   dq-alert / crd-alert — unify into a shared primitive. */

/* diligencia context under the head (id + carátula) */
.cod-ctx {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 14px;
}
.cod-ctx__id {
  font-family: var(--mono);
  font-size: var(--fs-2xs);
  font-variant-numeric: tabular-nums;
  color: var(--text-muted);
  white-space: nowrap;
}
.cod-ctx__t {
  font-size: var(--fs-2xs);
  color: var(--text-secondary);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* charge breakdown */
.cod-totals {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.cod-row {
  display: flex;
  justify-content: space-between;
  font-size: var(--fs-2xs);
  color: var(--text-secondary);
}
.cod-row span:last-child {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  color: var(--text-secondary);
}
.cod-row--grand {
  margin-top: 4px;
  padding-top: 9px;
  border-top: 1px solid var(--border-soft);
  font-size: var(--fs-detail);
  color: var(--text);
}
.cod-row--grand span:last-child {
  color: var(--text);
}

.cod-nobill {
  font-size: var(--fs-2xs);
  color: var(--text-muted);
  line-height: 1.5;
}

/* jump that unblocks the pay (missing billing profile) */
.cod-link {
  display: inline-flex;
  margin-top: 8px;
  padding: 0;
  border: 0;
  background: none;
  font-family: var(--sans);
  font-size: var(--fs-2xs);
  font-weight: 500;
  color: var(--signal-deep, #0957c8);
  cursor: pointer;
}
.cod-link:hover {
  text-decoration: underline;
}

/* footer buttons (same language as vd-btn) */
.cod-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: var(--r-data);
  font-family: var(--sans);
  font-size: var(--fs-detail);
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}
.cod-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.cod-btn--ghost {
  background: transparent;
  color: var(--text-secondary);
}
.cod-btn--ghost:hover {
  background: var(--bg-alt);
  color: var(--text);
}
.cod-btn--seal {
  background: var(--ink-dark);
  color: var(--cream);
  border-color: var(--ink-dark);
  box-shadow: inset 0 0 0 1px rgba(242, 227, 181, 0.16);
}
.cod-btn--seal:hover:not(:disabled) {
  background: #060e22;
}
[data-theme='dark'] .cod-btn--seal {
  background: var(--cream);
  color: var(--ink-dark);
  border-color: var(--cream);
}

/* exclusivity alert (always present under the breakdown) */
.cod-alert {
  display: flex;
  gap: 9px;
  align-items: flex-start;
  border: 1px solid var(--border-soft);
  border-radius: var(--r-data);
  padding: 11px 13px;
  margin-top: 14px;
  font-size: var(--fs-meta);
  line-height: 1.5;
  color: var(--text-secondary);
  background: var(--info-bg, #eff6ff);
}
.cod-alert svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 1px;
  stroke: currentColor;
  stroke-width: 1.7;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  color: var(--info, #175cd3);
}
.cod-alert b {
  color: var(--text);
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/shared/CheckoutModal/CheckoutModal.css"],"names":[],"mappings":"AAAA;;;;0DAI0D;;AAE1D,sDAAsD;AACtD;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,kCAAkC;EAClC,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;;AAEA,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;EAC7B,qDAAqD;AACvD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* CheckoutModal — shared checkout of one offer (\"Pasarela de pago\" step,\n   @/ui/Modal shell). Styles inherited from the retired CheckoutDrawer (which\n   mirrored the vd-co-* / vd-btn / vd-alert set that lived in\n   VerDiligenciaRoute.css). Pending back-port: the info alert also exists as\n   dq-alert / crd-alert — unify into a shared primitive. */\n\n/* diligencia context under the head (id + carátula) */\n.cod-ctx {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n.cod-ctx__id {\n  font-family: var(--mono);\n  font-size: var(--fs-2xs);\n  font-variant-numeric: tabular-nums;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n.cod-ctx__t {\n  font-size: var(--fs-2xs);\n  color: var(--text-secondary);\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* charge breakdown */\n.cod-totals {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.cod-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: var(--fs-2xs);\n  color: var(--text-secondary);\n}\n.cod-row span:last-child {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  color: var(--text-secondary);\n}\n.cod-row--grand {\n  margin-top: 4px;\n  padding-top: 9px;\n  border-top: 1px solid var(--border-soft);\n  font-size: var(--fs-detail);\n  color: var(--text);\n}\n.cod-row--grand span:last-child {\n  color: var(--text);\n}\n\n.cod-nobill {\n  font-size: var(--fs-2xs);\n  color: var(--text-muted);\n  line-height: 1.5;\n}\n\n/* jump that unblocks the pay (missing billing profile) */\n.cod-link {\n  display: inline-flex;\n  margin-top: 8px;\n  padding: 0;\n  border: 0;\n  background: none;\n  font-family: var(--sans);\n  font-size: var(--fs-2xs);\n  font-weight: 500;\n  color: var(--signal-deep, #0957c8);\n  cursor: pointer;\n}\n.cod-link:hover {\n  text-decoration: underline;\n}\n\n/* footer buttons (same language as vd-btn) */\n.cod-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 38px;\n  padding: 0 18px;\n  border: 1px solid transparent;\n  border-radius: var(--r-data);\n  font-family: var(--sans);\n  font-size: var(--fs-detail);\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.cod-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.cod-btn--ghost {\n  background: transparent;\n  color: var(--text-secondary);\n}\n.cod-btn--ghost:hover {\n  background: var(--bg-alt);\n  color: var(--text);\n}\n.cod-btn--seal {\n  background: var(--ink-dark);\n  color: var(--cream);\n  border-color: var(--ink-dark);\n  box-shadow: inset 0 0 0 1px rgba(242, 227, 181, 0.16);\n}\n.cod-btn--seal:hover:not(:disabled) {\n  background: #060e22;\n}\n[data-theme='dark'] .cod-btn--seal {\n  background: var(--cream);\n  color: var(--ink-dark);\n  border-color: var(--cream);\n}\n\n/* exclusivity alert (always present under the breakdown) */\n.cod-alert {\n  display: flex;\n  gap: 9px;\n  align-items: flex-start;\n  border: 1px solid var(--border-soft);\n  border-radius: var(--r-data);\n  padding: 11px 13px;\n  margin-top: 14px;\n  font-size: var(--fs-meta);\n  line-height: 1.5;\n  color: var(--text-secondary);\n  background: var(--info-bg, #eff6ff);\n}\n.cod-alert svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  margin-top: 1px;\n  stroke: currentColor;\n  stroke-width: 1.7;\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  color: var(--info, #175cd3);\n}\n.cod-alert b {\n  color: var(--text);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
